import { BitrixVue } from 'ui.vue';

BitrixVue.component('InteriorModal', {
	data() {
		return { selectedDoor: null };
	},
	methods: {
		showModal(modal) {
			this.$refs[modal].open();
		},
	},
	props: ['items'],
	template: `
	<div class="config-left__interior" @click="showModal('interiorModal')">
		<ui-tooltip position="right" animation="fade">Смотреть в интерьере</ui-tooltip>
		<ui-modal ref="interiorModal" transition="fade" class="interior-modal config-modal" size="large">
			<div class="interior-modal__wrap">
				
			</div>
		</ui-modal>
	</div>
`,
});
